/** Base path for all influencer routes (must match App.js route path) */
export const INFLUENCER_BASE = '/influencer';
